import { toast } from 'react-toastify';

import moment from 'moment';
import qs from 'querystring';
import { takeLatest, call, put, all } from 'redux-saga/effects';

import { t } from '~/helpers';
import api from '~/services/api';
import history from '~/services/history';

import {
  successInRequest,
  failedRequest,
  successRemove,
  successRequest,
} from './actions';

export function* requestOperacaoNotaFiscalDescargas({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'operacaonotafiscaldescargas', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });
    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* deleteOperacaoNotaFiscalDescargas({ payload }) {
  try {
    const { nfre_numero, params } = payload;

    yield call(api.delete, `operacaonotafiscaldescargas/${nfre_numero}`);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoexclusao'));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* store({ payload }) {
  try {
    const { operacaonotafiscaldescarga, params } = payload;

    yield call(
      api.post,
      'operacaonotafiscaldescargas',
      operacaonotafiscaldescarga
    );
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoinclusao'));
    history.push('/notafiscaldescargas');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* find({ payload }) {
  try {
    const { nfre_numero } = payload;

    const { data } = yield call(
      api.get,
      `operacaonotafiscaldescargas/${nfre_numero}`
    );

    const dataMod = {
      ...data,
      datahorainicialmovimentacao: moment(
        data.datahorainicialmovimentacao,
        'DD/MM/YYYY HH:mm:ss',
        true
      ).format('YYYY-MM-DDTHH:mm:ss'),
      datahorafinalmovimentacao: moment(
        data.datahorafinalmovimentacao,
        'DD/MM/YYYY HH:mm:ss',
        true
      ).format('YYYY-MM-DDTHH:mm:ss'),
    };

    yield put(successRequest(dataMod));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* update({ payload }) {
  try {
    const { operacaonotafiscaldescarga, params } = payload;

    yield call(
      api.put,
      'operacaonotafiscaldescargas',
      operacaonotafiscaldescarga
    );
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoalteracao'));
    history.push('/notafiscaldescargas');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* applyedFilters({ payload }) {
  try {
    const { params } = payload;

    const response = yield call(api.get, 'operacaonotafiscaldescargas', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export default all([
  takeLatest(
    '@operacaonotafiscaldescargas/NOTAFISCALDESCARGAS_IN_REQUEST',
    requestOperacaoNotaFiscalDescargas
  ),
  takeLatest(
    '@operacaonotafiscaldescargas/DELETE_NOTAFISCALDESCARGAS',
    deleteOperacaoNotaFiscalDescargas
  ),
  takeLatest(
    '@operacaonotafiscaldescargas/SUCCESS_REMOVE',
    requestOperacaoNotaFiscalDescargas
  ),
  takeLatest('@operacaonotafiscaldescargas/STORE_NOTAFISCALDESCARGAS', store),
  takeLatest('@operacaonotafiscaldescargas/FIND_NOTAFISCALDESCARGAS', find),
  takeLatest('@operacaonotafiscaldescargas/UPDATE_NOTAFISCALDESCARGAS', update),
  takeLatest('@operacaonotafiscaldescargas/RECORD_FILTERING', applyedFilters),
]);
